import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => {
  const {
    thumb,
    track,
    thumbChecked,
    trackChecked,
    thumbDisabled,
    trackDisabled,
    off
  } = theme.palette.switch

  const imp = val => `${val} !important`

  return {
    root: {
      display: 'flex',
      width: '28px',
      height: '16px',
      padding: '0',

      '& .MuiSwitch-switchBase': {
        padding: '2px'
      },

      '& .MuiSwitch-thumb': {
        borderColor: thumb,
        backgroundColor: thumb,
        boxShadow: 'none',
        width: '12px',
        height: '12px'
      },

      '& .MuiSwitch-track': {
        border: `1px solid ${track}`,
        backgroundColor: track,
        boxSizing: 'border-box',
        borderRadius: '8px',
        opacity: '1'
      }
    },

    checked: {
      '& .MuiSwitch-switchBase': {
        transform: imp('translateX(12px)')
      },

      '& .MuiSwitch-thumb': {
        borderColor: imp(thumbChecked),
        backgroundColor: imp(thumbChecked)
      },

      '& .MuiSwitch-track': {
        borderColor: imp(trackChecked),
        backgroundColor: imp(trackChecked),
        opacity: imp(1)
      }
    },

    disabled: {
      '& .MuiSwitch-thumb': {
        borderColor: imp(thumbDisabled),
        backgroundColor: imp(thumbDisabled)
      },

      '& .MuiSwitch-track': {
        borderColor: imp(trackDisabled),
        backgroundColor: imp(trackDisabled),
        opacity: imp(0.5)
      }
    },

    off: {
      '& .MuiSwitch-track': {
        borderColor: imp(off),
        backgroundColor: imp(off),
        opacity: imp(1)
      }
    }
  }
})

export default useStyles
